/* eslint-disable @typescript-eslint/no-unused-expressions */
import { useRouter, useValidation } from '@application/utils';
import type { BookingPageFormValues } from '@presentation/pages';
import type { FormikErrors } from 'formik';
import { useCallback } from 'react';

export interface UseValidateBookingPageFormParams {
  forMultiAnimals: boolean;
}

export const useValidateBookingPageForm = (params: UseValidateBookingPageFormParams) => {
  const { forMultiAnimals } = params;
  const { translate } = useRouter();

  const { requiredMessage, isValidMobilePhone } = useValidation();

  const validateBookingPageForm = useCallback(
    (values: BookingPageFormValues) => {
      const errors: FormikErrors<BookingPageFormValues> = {};

      if (!values.bookingReason) {
        errors.bookingReason = requiredMessage;
      }

      if (!values.bookingStart) {
        errors.bookingStart = requiredMessage;
      }

      if (!values.animalIds.length) {
        errors.animalIds = requiredMessage;
      }

      if (forMultiAnimals && values.animalIds?.length < 2) {
        errors.animalIds = translate('common.validation.notEnoughAnimals');
      }

      if (values.shouldRequirePhoneNumber && !values.phoneNumber) {
        errors.phoneNumber = requiredMessage;
      }

      if (values.phoneNumber && !isValidMobilePhone(values.phoneNumber)) {
        errors.phoneNumber = translate('common.validation.invalidMobilePhone');
      }

      return errors;
    },
    [forMultiAnimals, isValidMobilePhone, requiredMessage, translate],
  );
  return { validateBookingPageForm };
};
